import * as THREE from 'three';
import { G, M, TINT, glowMat, mesh, plate, rib, mergeBones, stages, boneG } from './kit';
/* ============================================================
   STILLE 靜默 —— BOSS・不動
   ============================================================

   剪影：10 單位死黑方尖碑＋十一片碎片
   階段：'P1 完全靜止・只有瞬間轉向','P2 碎片加速・碑仍不動','P3 碑第一次真的動了'

   由 `tools/port-bosses.mjs` 從 `enemy_sample_ani.html` 機械移植，
   **不要手改這個檔**：要改造型請改原型再重跑移植器，否則 1:1 就斷了。
   驗證：`node tools/port-bosses.mjs --check`。
   ⚠️ 比對只守得住數字與字串，**動畫對不對只能實看**（圖鑑的開發模式）。 */


/* ── BOSS-23 STILLE 靜默 ── 它不動。
   一根 10 單位的死黑方尖碑，沒有腿、沒有推進器、沒有任何會動的部件。
   它唯一的動作是轉向你 —— 而且是「瞬間跳過去」，沒有插值。
   平滑轉向讀作機械，瞬跳讀作「它一直在看，只是你剛才沒注意」。
   P1 完全靜止，只有碎片環在轉。P2 碎片加速、碑仍不動。
   P3 碑第一次真的動了 —— 整根傾斜並開始位移。這時候你才知道它一直做得到。 */
var STN = 11;
export function buildStille(){
  var GLV = glowMat(TINT.vio.hex, 2.6), GLA = glowMat(TINT.amb.hex, 2.2);
  var root = new THREE.Group(), shards = [], i;
  var ob = boneG(root, 0, 0, 0);
  ob.add(mesh(G.box, M.void,  [2.30, 9.60, 2.30], [0, 4.90, 0]));
  ob.add(rib (M.armor, 0.18, 9.20, 0.18, [ 1.18, 4.90, 1.18]));
  ob.add(rib (M.armor, 0.18, 9.20, 0.18, [-1.18, 4.90, 1.18]));
  ob.add(rib (M.armor, 0.18, 9.20, 0.18, [ 1.18, 4.90,-1.18]));
  ob.add(rib (M.armor, 0.18, 9.20, 0.18, [-1.18, 4.90,-1.18]));
  ob.add(mesh(G.cone, M.void, [2.30, 1.60, 2.30], [0, 10.5, 0]));
  ob.add(plate(M.armor, 1.90, 0.40, 0.30, [0, 9.40, 1.20], -0.30));
  var eye = mesh(G.oct, GLV, [1.30, 1.30, 1.30], [0, 7.40, 1.15]);
  eye.userData.noMerge = 1; ob.add(eye);
  var brow = mesh(G.tor, GLV, [2.10, 2.10, 0.30], [0, 7.40, 1.05]);
  brow.userData.noMerge = 1; ob.add(brow);
  for (i = 0; i < STN; i++){                        // 十一 —— 又一個鋪不滿的數
    var a = i*Math.PI * 2/STN;
    var sd = boneG(root, 0, 0, 0); sd.rotation.y = a;
    var r = 4.20 + (i % 3)*1.10, hy = 2.40 + (i % 4)*1.90;
    sd.add(mesh(G.oct, M.armor, [0.90, 1.40, 0.90], [0, hy, r], [0.3*i, 0.2*i, 0]));
    var g = mesh(G.box, GLA, [0.60, 0.10, 0.10], [0, hy + 0.50, r]);
    g.userData.noMerge = 1; sd.add(g);
    shards.push({sd:sd, i:i, r:r, hy:hy});
  }
  root.userData.rig = {ob:ob, eye:eye, brow:brow, shards:shards, GLV:GLV, GLA:GLA};
  return mergeBones(root);
}
export function updStille(rig, o, dt){
  stages(rig, o, dt, 1.2);
  var s1 = rig.s1, s2 = rig.s2, i, S;
  /* ⭐ 這一行是整隻的核心：量化到 Math.PI * 2/12，所以永遠是瞬間跳過去，沒有中間值。 */
  var q = Math.PI * 2/12;
  rig.ob.rotation.y = Math.round((o.t*0.42) / q) * q;
  rig.ob.rotation.z = 0.34*s2*Math.sin(o.t*0.5);    // 三階段才第一次真的動
  rig.ob.position.x = 2.60*s2*Math.sin(o.t*0.34);
  rig.ob.position.y = 0.60*s2;
  for (i = 0; i < STN; i++){
    S = rig.shards[i];
    S.sd.rotation.y += dt*(0.30 + 1.9*s1 + 3.6*s2)*(i % 2 ? 1 : -1);
    S.sd.rotation.x = (0.12 + 0.30*s1)*Math.sin(o.t*0.8 + i);
    S.sd.scale.setScalar(1 + 0.30*s1 + 0.20*Math.sin(o.t*2.2 + i*1.3));
  }
  rig.eye.scale.setScalar(1 + 0.14*Math.sin(o.t*1.6) + 1.2*o.tel + 0.5*s2);
  rig.brow.rotation.z += dt*(0.4 + 2.2*s2);
  rig.GLV.emissiveIntensity = 2.6 + 3.0*o.tel + 6*o.atk*(1-o.atk) + 1.4*s2;
  rig.GLA.emissiveIntensity = 1.4 + 1.6*s1 + 2.2*s2;
}